// Output time in the following format 2016-04-07 12:22:21,844

function addZero(num) {
    if (num < 10) {
        return '0' + num;
    } else {
        return num;
    }
}

function addTwoZero(num) {
    if (num < 10) {
        return '00' + num;
    } else if (num < 100) {
        return '0' + num;
    } else {
        return num;
    }
}

module.exports = function printTimestamp() {
    var time = new Date();

    return (
        time.getFullYear() +
        '-' +
        addZero(time.getMonth() + 1) +
        '-' +
        addZero(time.getDate()) +
        ' ' +
        addZero(time.getHours()) +
        ':' +
        addZero(time.getMinutes()) +
        ':' +
        addZero(time.getSeconds()) +
        ',' +
        addTwoZero(time.getMilliseconds())
    );
};
